import Citizen from '../images/citizen.png'
import Love from '../images/love.png'
import Compassion from '../images/compassion.png'
import Work from '../images/work.png'
import Integrity from '../images/integrity.png'


const values = [
  {
    id: 1,
    image: Citizen,
    name: 'Citizenship',
    description: 'I am committed to be the change I want to see, starting from me, in my family, community, and the country',
  },
  {
      id: 2,
      image: Love,
      name: 'Love',
      description: 'Whatever I do is done by an act of love',
  },
  {
      id: 3,
      image: Compassion,
      name: 'Compassion',
      description: 'Kindness and empathy is our family  language',
  },
  {
      id: 4,
      image: Work,
      name: 'Hard work',
      description: 'I work hard to succeed and make a difference',
  },
  {
      id: 5,
      image: Integrity,
      name: 'Integrity',
      description: 'My words are my actions even in the secret place where no one is seeing me',
  },
]
  
export default function Example() {
    return (
      <div id='about' >
        <div className="relative isolate flex items-center just gap-x-6 overflow-hidden bg-sky-600 px-6 py-2.5 pb-8 sm:px-3.5 sm:before:flex-1">
          <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-5 xl:gap-x-8">
                {values.map((value) => (
                  <div key={value.id} className="group items-center relative rounded-md bg-white shadow p-8">
                  <div className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
                          aria-hidden="true">
                    <div className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#facc15] to-[#0284c7] opacity-30"
                          style={{
                            clipPath:
                              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                          }}/>
                    </div>
                    <div className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
                            aria-hidden="true">
                      <div className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#facc15] to-[#0284c7] opacity-30"
                            style={{
                              clipPath:
                                'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                            }}/>
                    </div>
                    <div className="flex justify-center">
                      <img className='h-14' src={value.image} alt='' />
                    </div>
                    <div className="mt-4 text-center ">
                        <h3 className="text-lg text-black font-bold">
                            {value.name}
                        </h3>
                        <p className="mt-1 text-sm text-black">{value.description}</p>
                    </div>
                  </div>
                ))}
              </div>
          <div className="flex flex-1 justify-end">
          </div>
        </div>


        {/* <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-5 sm:py-10 sm:px-3.5 sm:before:flex-1">
            <div
              className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
              aria-hidden="true"
            >
              <div
                className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#facc15] to-[#0284c7] opacity-30"
                style={{
                  clipPath:
                    'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                }}
              />
            </div>
            <div
              className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
              aria-hidden="true"
            >
              <div
                className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#facc15] to-[#0284c7] opacity-30"
                style={{
                  clipPath:
                    'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
                }}
              />
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <p className="text-base leading-6 text-gray-900">
                <strong className="font-semibold">Objectives </strong>
                <span aria-hidden="true">&rarr;</span> Empower and educate Kids 
                <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                  <circle cx={1} cy={1} r={1} />
                </svg>
                Promote child protection and ensure respects of the Rights 
                <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                  <circle cx={1} cy={1} r={1} />
                </svg>
                Promote social inclusion and equity 
                <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                  <circle cx={1} cy={1} r={1} />
                </svg>
                Empower women, build resilient families, and promote healthy environment favorable for child wellbeing   

              </p>
              
            </div>
          <div className="flex flex-1 justify-end">
          
          </div>
        </div> */}

      </div>
    )
  }
  